import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	loading: {
		id: 'servicedesk-insight-object-schema-page.page-content.loaded.page-content.object-list.loading',
		defaultMessage: 'Loading',
		description: 'Label to display objects are being loaded from the server',
	},
});
